import { Button, Col, Row } from "react-bootstrap";
import { FormattedMessage } from "react-intl";
import { useAppSelector } from "../../store/hooks";
import { selectCurrentClient, selectIsLoggedIn, selectIsUserEcostern } from "../../store/slices/userSlice";
import * as serviceWorkerRegistration from "serviceWorkerRegistration";
import { CartzillaIcon, CartzillaIconName } from "components/ui/icons/cartzilla-icon";
import { useState } from "react";
import pkg from "../../../package.json";
import { PrivacyModal } from "components/modals/privacy-modal";

export const Footer = () => {
    const currentClient = useAppSelector(selectCurrentClient);
    const [isUpdating, setIsUpdating] = useState(false);
    const [isPrivacyModalOpen, setIsPrivacyModalOpen] = useState(false);
    const isLoggedIn = useAppSelector(selectIsLoggedIn);
    const isUserEcostern = useAppSelector(selectIsUserEcostern);
    const hasPrivacySettings = isLoggedIn && !isUserEcostern;

    const updateVersion = () => {
        setIsUpdating(true);
        const now = Date.now();
        serviceWorkerRegistration.update({
            onUpdate: () => {
                // Ensure that the animation is visible for at least 1 second
                const timeDiff = Date.now() - now;
                if (timeDiff > 1000) {
                    setIsUpdating(false);
                } else {
                    setTimeout(() => setIsUpdating(false), 1000 - timeDiff);
                }
            },
        });
    };

    return (
        <footer className="bg-dark py-5 pb-md-3">
            <div className="container">
                <div className="row pb-2">
                    <div className="col-md-3">
                        <div className="widget widget-links widget-light pb-2 mb-4">
                            <h3 className="widget-title text-light">Ecostern OÜ</h3>
                            <ul className="widget-list text-light opacity-50">
                                <li className="widget-list-item">
                                    Põikmäe tn 2, Tänassilma <br /> 76406 Saku vald, Harjumaa
                                </li>
                                <li className="widget-list-item">+372 648 0000</li>
                                <li className="widget-list-item">
                                    <a href={"mailto:info@ecostern.ee"} className={"text-light"}>
                                        info@ecostern.ee
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div className="col-md-3">
                        <div className="widget widget-links widget-light pb-2 mb-4">
                            <h3 className="widget-title text-light">
                                <FormattedMessage id={"footer.warehouse"} />
                            </h3>
                            <ul className="widget-list text-light opacity-50">
                                <li className="widget-list-item">
                                    Härgmäe tn 8, 13525 <br />
                                    Tallinn, Harjumaa
                                </li>
                                <li className="widget-list-item">Estakaad nr 4</li>
                                <li className="widget-list-item">
                                    <FormattedMessage id={"footer.warehouse.openingTimes"} />
                                </li>
                                <li className="widget-list-item">
                                    <a href="tel:+372 59 190 392" className="text-light">
                                        +372 59 190 392
                                    </a>
                                </li>
                                <li className="widget-list-item">
                                    <a href="mailto:info@ecostern.ee" className="text-light">
                                        info@ecostern.ee
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </div>
                    {currentClient && (
                        <>
                            <div className="col-md-3">
                                <div className="widget widget-links widget-light pb-2 mb-4">
                                    <h3 className="widget-title text-light">
                                        <FormattedMessage id={"contact.contact"} />
                                    </h3>
                                    <ul className="widget-list text-light opacity-50">
                                        <li className="widget-list-item">{currentClient.contactName}</li>
                                        <li className="widget-list-item">{currentClient.contactPhone}</li>
                                        <li className="widget-list-item">
                                            <a href={`mailto:${currentClient.contactEmail}`} className={"text-light"}>
                                                {currentClient.contactEmail}
                                            </a>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                            <div className="col-md-3">
                                {currentClient.name && (
                                    <div className="widget widget-links widget-light pb-2 mb-4">
                                        <h3 className="widget-title text-light">
                                            <FormattedMessage id={"footer.client"} />
                                        </h3>
                                        <ul className="widget-list text-light opacity-50">
                                            <li className="widget-list-item">{currentClient.name}</li>
                                        </ul>
                                    </div>
                                )}
                            </div>
                        </>
                    )}
                </div>
                <Row className={"pt-2 pb-4 pb-md-0 justify-content-between align-items-center"}>
                    <Col xs={"auto"} className={"fs-xs text-light opacity-50"}>
                        © Kõik õigused kaitstud.
                        {hasPrivacySettings && (
                            <Button
                                variant={"solid-link"}
                                size={"sm"}
                                className={"text-light fs-xs px-2 py-1 ms-2"}
                                onClick={() => setIsPrivacyModalOpen(true)}
                            >
                                <FormattedMessage id={"footer.privacy"} />
                            </Button>
                        )}
                    </Col>
                    <Col xs={"auto"} className={"fs-xs text-light opacity-50"}>
                        <Button variant={"solid-link"} onClick={updateVersion} size={"sm"} className={"text-light flex align-items-center fs-xs px-2 py-1"}>
                            <span className={"me-2"}>{`v. ${pkg.version} - ${process.env.REACT_APP_GIT_SHA}`}</span>
                            {isUpdating && <CartzillaIcon icon={CartzillaIconName.Loading} className={"animate-spin"} />}
                        </Button>
                    </Col>
                </Row>
            </div>
            {hasPrivacySettings && <PrivacyModal show={isPrivacyModalOpen} onHide={() => setIsPrivacyModalOpen(false)} />}
        </footer>
    );
};
